import { showEmeraldDialog } from '../../common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import { popEmeraldModal } from '../../common/emerald-modal-manager/emerald-modal-manager';
import { EmeraldDialogTypes } from '../../common/enumerations/emerald-dialog-types';
import { store } from '../../common/redux/configure-store';
import { MenuPanelActions } from '../../common/redux/reducers/menu-panel-reducer';
import { ResetPasswordActions } from '../../common/redux/reducers/reset-password-reducer';
import { logout } from '../../home-page/business-logic/logout';

export const forgotPassword = async (): Promise<void> => {
  store.dispatch(ResetPasswordActions.setResetPassword(true));
  store.dispatch(MenuPanelActions.toggle());
};

export const showResetPasswordSuccessModal = (
  showResetSuccessModal: boolean,
  userName?: string,
): void => {
  if (showResetSuccessModal) {
    store.dispatch(ResetPasswordActions.cancelReset());
    const messageItem = {
      message: 'ResetSuccessful',
      type: EmeraldDialogTypes.Info,
      subMessage: 'PasswordResetSuccess',
      onAccept: () => {
        popEmeraldModal();
      },
      onCancel: () => {
        logout();
      },
      acceptButtonLabel: 'Ok',
      closeButtonLabel: 'ItemErrorControl_YesNo_Begin',
      subMessageArgs: { arg: userName ?? '' },
    };
    showEmeraldDialog(messageItem);
  }
};
